'use client'
import { useGetUserByItineraryQuery } from '@/src/api/rtkQuery/itineraryApi'
import { getUserAuthValues } from '@/src/utils/auth'
import { getCookie } from '@/src/utils/browser'
import { isEmpty } from '@/src/utils/generalUtils/isEmpty'
import { useEffect, useState } from 'react'
import useGetItineraryId from '../useGetItineraryId'

export const useGetSaveTravelerData = () => {
    const [canCallUserApi, setCanCallUserApi] = useState(false)
    const itineraryId = useGetItineraryId()
    const {
        data: userData,
        isLoading: isUserLoading,
        error: userError
    } = useGetUserByItineraryQuery(
        {
            itineraryId
        },
        {
            skip: !canCallUserApi
        }
    )

    useEffect(() => {
        if (itineraryId) {
            const usermisc = getCookie('usermisc') || ''
            const { email: signedInEmail = '', userId = '' } = getUserAuthValues()
            if (usermisc.includes('SIGNED_IN') && !isEmpty(userId)) {
                setCanCallUserApi(true)
            }
        }
    }, [itineraryId])

    return { userData, isUserLoading, userError }
}
